export default __webpack_public_path__ + "static/media/glasses.9f340396.png";